import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from '../Pages/Home'
import Login from '../Layouts/Login';
import Dashboard from '../Layouts/Dashboard';
import MyOrderDashboard from '../MyOrder/MyOrderDashboard';
import NewOrderDashboardJs from '../JuiceDashboard/NewOrderDashboard';
import CartDashboard from '../OrderCart/CartDashboard';
import ProductsDashboard from '../Products/ProductsDashboard';
import RaiseQueryDashboard from '../RaiseQuery/RaiseQueryDashboard';
import RecommendationDashboard from '../Recommendation/RecommendationDashboard';
import SpreadWordDashboard from '../SpreadWord/SpreadWordDashboard';
import OrderSummaryJuice from '../JuiceDashboard/OrderSummary';

import CreateQuery from '../RaiseQuery/CreateQuery';
import OrderDetails from '../MyOrder/OrderDetails';
import CropWiseReccomandations from '../MoreInformation/CropWiseReccomandations'
import DelearFinance from '../MoreInformation/DelearFinance'
import ExpiringStock from '../MoreInformation/ExpiringStock'
import Geetings from '../MoreInformation/Geetings'
import Tips from '../MoreInformation/Tips'
import MoreInformationDashboard from '../MoreInformation/MoreInformationDashboard'
import OurTeamContacts from '../MoreInformation/OurTeamContacts'
import Yashogatha from '../MoreInformation/Yashogatha'
import Videos from '../MoreInformation/Videos'
import WorkGuidence from '../MoreInformation/WorkGuidence'
import WorkGuidenceEvents from '../MoreInformation/WorkGuidenceEvents'
import Articals from '../MoreInformation/Articals'
import ProductNeverOrder from '../MoreInformation/ProductNeverOrder'
import ShareObservations from '../MoreInformation/ShareObservations'
import ChannelObservationList from '../MoreInformation/ChannelObservationList'
import Profitability from '../MoreInformation/Profitability'
import ProfileDashboard from '../Profile/ProfileDashboard';
import NotificationDashboard from '../Notifications/NotificationDashboard';
import NativeLoginSuccessful from '../Layouts/NativeLoginSuccessful';
import Logout from '../Layouts/Logout';
import BPUPaymentList from '../BPUser/BPUPaymentList';
import BPUOrderList from '../BPUser/BPUOrderList';
import BPUDashboard from '../BPUser/BPUDashboard';
import BPUProfile from '../BPUser/BPUProfile';
import BPUDashContent from '../BPUser/BPUDashContent';
import BPUPaymentDetails from '../BPUser/BPUPaymentDetails';
import BPUOrderDetails from '../BPUser/BPUOrderDetails';
import BPDemoRoute from '../BPUser/BPDemoRoute';
import OrderTransactionDetails from '../JuiceDashboard/OrderTransactionDetails';
import TermsAndConditions from '../Pages/TermsAndConditions';
import PrivacyPolicy from '../Pages/PrivacyPolicy';
import ShippingandDelivery from '../Pages/ShippingandDelivery';
import CancellationandRefund from '../Pages/CancellationandRefund';
import ContactUs from '../Pages/ContactUs';
import PaymentStatus_Failed from '../Pages/PaymentStatus_Failed';
import PaymentStatus_Success from '../Pages/PaymentStatus_Success';


const initialHistoryLength = window.history.length;

window.addEventListener('popstate', function (event) {
  if (window.history.length < initialHistoryLength) {
    window.history.back(-1);
  }
});


const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/BPDemoRoute" element={<BPDemoRoute />} />
        <Route path="/Login" element={<Login />} />
        <Route path='/NativeLoginSuccessful' element={<NativeLoginSuccessful />} />
        <Route path='/Logout' element={<Logout />} />
        <Route path="/pages/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="/pages/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/pages/ShippingandDelivery" element={<ShippingandDelivery />} />
        <Route path="/pages/CancellationandRefund" element={<CancellationandRefund />} />
        <Route path="/pages/ContactUs" element={<ContactUs />} />
        <Route path="/PaymentStatus_Failed" element={<PaymentStatus_Failed />} />
        <Route path="/PaymentStatus_Success" element={<PaymentStatus_Success />} />
        <Route path='/BPUDashboard' element={<BPUDashboard />} >
          <Route path='PaymentList/:Id' element={<BPUPaymentList />} > </Route>
          <Route path='OrderList/:Id' element={<BPUOrderList />} > </Route>
          <Route path='BPUPaymentDetails/:Id' element={<BPUPaymentDetails />}></Route>
          <Route path='BPUOrderDetails/:Id' element={<BPUOrderDetails />}></Route>
          <Route path='BPUProfile' element={<BPUProfile />} > </Route>
          <Route path='BPUDashContent' element={<BPUDashContent />} > </Route>
        </Route>
        <Route path="/" element={<Dashboard />} >
          <Route path="/" element={<Home />} >
            <Route path='OrderSummaryJuice' element={<OrderSummaryJuice />}> </Route>
          </Route>
          <Route path='MyOrder' element={<MyOrderDashboard />}></Route>
          <Route path='OrderDetails/:Id' element={<OrderDetails />}> </Route>
          <Route path='Carts' element={<CartDashboard />}> </Route>
          <Route path='Products' element={<ProductsDashboard />}> </Route>
          <Route path='RaiseQuery' element={<RaiseQueryDashboard />}> </Route>
          <Route path='CreateQuery' element={<CreateQuery />}> </Route>
          <Route path='Recommendation' element={<RecommendationDashboard />}> </Route>
          <Route path='SpreadTheWord' element={<SpreadWordDashboard />}> </Route>
          <Route path='Articles' element={<Articals />} > </Route>
          <Route path='CropWiseReccomandations' element={<CropWiseReccomandations />} > </Route>
          <Route path='DelearFinance' element={<DelearFinance />} > </Route>
          <Route path='ExpiringStock' element={<ExpiringStock />} > </Route>
          <Route path='Greetings' element={<Geetings />} > </Route>
          <Route path='Tips' element={<Tips />} > </Route>
          <Route path='MoreInformation' element={<MoreInformationDashboard />} > </Route>
          <Route path='OurTeamContacts' element={<OurTeamContacts />} > </Route>
          <Route path='ProductNeverOrder' element={<ProductNeverOrder />} > </Route>
          <Route path='ShareObservations' element={<ShareObservations />} > </Route>
          <Route path='ChannelObservationList' element={<ChannelObservationList />} > </Route>
          <Route path='Yashogatha' element={<Yashogatha />} > </Route>
          <Route path='Videos' element={<Videos />} > </Route>
          <Route path='WorkGuidence' element={<WorkGuidence />} > </Route>
          <Route path='Profitability' element={<Profitability />} > </Route>
          <Route path='WorkGuidenceEvents' element={<WorkGuidenceEvents />} > </Route>
          <Route path='ProfileDashboard' element={<ProfileDashboard />}> </Route>
          <Route path='NotificationDashboard' element={<NotificationDashboard />} ></Route>
          <Route path='OrderTransactionDetails' element={<OrderTransactionDetails />} ></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Navigation